import autocomplete from 'autocompleter';
import {$, $$, createElement, hide, removeChildElementByClass, show} from "../../core/js/Dom.ts";
import {$get} from "../../core/js/Ajax.ts";
import {Stepper} from "../../core/js/Stepper.ts";
import {ajouterLiensPageAide} from "./FormUtils.ts";
import {addLabelInformations} from "../../core/js/FormHelper.ts";
import {createIcon} from "../../core/js/Dom.ts";
import {fadeIn, fadeOutFadeIn} from "../../core/js/Animate.ts";
import {checkIfDateIsBefore, checkIfDateIsFutur, checkIfDateIsLessThan365Days, createDateFromStringOrNull, resetAllOptionsWithName} from "../../core/js/Utils.ts";

const ivtm = createIcon('remix-vtm', 'Avec véhicule terrestre à moteur')
const icycl = createIcon('openscop-cyclisme', 'Cyclisme');
const i_vtm = createIcon('remix-sans-vtm', 'Sans véhicule terrestre à moteur');
const icomp = createIcon('remix-competition', 'Compétition');
const i_comp = createIcon('remix-sans-competition', 'Sans compétition');
const igroup = createIcon('remix-nombreux-participants', 'Circulation groupée');
const cyclisme_disciplines_competitif = ["Cyclisme"]
const cyclisme_disciplines_non_competitif = ["Cyclotourisme"]
const cyclisme_disciplines_all = [...cyclisme_disciplines_competitif, ...cyclisme_disciplines_non_competitif]


document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url === 'creation_dossier_sport') {
        const stepper = new Stepper('#stepper_recherche_formulaire')
        initState()
        initListener(stepper)
    }
})

function initListener(stepper: Stepper) {
    stepper.addEventListener('stepper:change', handleStepChanged)
    $('#id_discipline')?.addEventListener('change', (event) => {
        handleDisciplineChanged(event)
        checkCanGoToNextStep(stepper.currentStep)
        updateIcones()
    })
    // check next
    $('#id_nom')?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
    $('#id_date_debut')?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
    $('#id_date_fin')?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
    $('#id_activite')?.addEventListener('change', () => {
        checkCanGoToNextStep(stepper.currentStep)
    })
    $('#id_departement')?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
    $('#id_ville_depart')?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
    $('#id_nb_participants')?.addEventListener('keyup', () => {
        checkCanGoToNextStep(stepper.currentStep)
        updateIcones()
    })
    $('#id_competition')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
        updateCompetitionIcon(event.target)
        checkCanGoToNextStep(stepper.currentStep)
    })
    $('#id_site_pratique_circuit_sport_meca')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
        toggleTypeCircuit(event.target.checked, stepper)
    })
    $('#id_site_pratique_terrain')?.addEventListener('change', () => toggleSitePratique(stepper))
    $('#id_site_pratique_parcours')?.addEventListener('change', () => toggleSitePratique(stepper))
    $('#id_site_pratique_parcours_liaison')?.addEventListener('change', () => toggleSitePratique(stepper))
    $('#id_site_pratique_zone_evolution')?.addEventListener('change', () => toggleSitePratique(stepper))
    $('#id_site_pratique_concentration_vtm')?.addEventListener('change', () => toggleSitePratique(stepper))
    $$('[name="emprise"]').forEach(element => element?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep)))
    $$('[name="type_circuit"]').forEach(element => {
        element?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
        element?.addEventListener('change', () => handleCircuitNonPermanentSelectionner())
    })
}

function initState() {
    $$<HTMLButtonElement>('.stepper-next').forEach(button => button.disabled = true)
    initAutocomplete()
    updateIcones()
    updateCompetitionIcon($('#id_competition'))
}

function checkCanGoToNextStep(currentStep: number) {
    const form = $<HTMLFormElement>('#evenement-form');
    let canChange = false
    if (form) {
        const formData = new FormData(form)
        const discipline = String(formData.get('discipline'))
        switch (currentStep) {
            case 1:
                canChange = false
                const nom = formData.get("nom")
                const dateDebutStr = formData.get('date_debut') as string
                const dateFinStr = formData.get('date_fin') as string
                if (dateFinStr && dateDebutStr) {
                    const dateDebutDate = createDateFromStringOrNull(dateDebutStr)
                    const dateFinDate = createDateFromStringOrNull(dateFinStr)
                    if (nom && dateDebutDate && dateFinDate) {
                        if (checkIfDateIsBefore(dateDebutDate, dateFinDate) && checkIfDateIsLessThan365Days(dateDebutDate, dateFinDate) && checkIfDateIsFutur(dateDebutDate)) {
                            afficher_erreur_dates(form)
                            canChange = true
                        } else {
                            afficher_erreur_dates(form, true)
                        }
                    }
                }
                break;
            case 2:
                if (formData.get('discipline') && formData.get('activite')) {
                    canChange = true
                }
                break;
            case 3:
                if (formData.get('departement') !== "null" && formData.get('ville_depart') !== "null") {
                    canChange = true
                }
                break;
            case 4:
                if (formData.get('nb_participants')) {
                    canChange = true
                }
                break;
            case 5:
                if (isVTM(discipline)) {
                    // vtm donc il peut y avoir emprise + circuit
                    const hasEmprise = !!(formData.get('site_pratique_zone_evolution') || formData.get('site_pratique_parcours_liaison') || formData.get('site_pratique_parcours') || formData.get('site_pratique_terrain')) || formData.get('site_pratique_concentration_vtm')
                    const hasCircuit = !!(formData.get('site_pratique_circuit_sport_meca'))

                    if (hasEmprise && hasCircuit) {
                        canChange = !!(formData.get('emprise') && formData.get("type_circuit"))
                    } else if (hasEmprise) {
                        canChange = !!(formData.get('emprise'))
                    } else if (hasCircuit) canChange = !!(formData.get('type_circuit'))
                } else {
                    // pas vtm donc que emprise obligatoire
                    canChange = !!(formData.get('emprise'))
                }
                break;
        }
    }

    $<HTMLButtonElement>(`[data-step="${currentStep}"] .stepper-next`)!.disabled = !canChange
    return canChange
}

function afficher_erreur_dates(form: HTMLFormElement, display: boolean = false) {
    $('#error-date', form)?.remove()
    if (display) {
        const error = createElement("p", ['fr-error-text'])
        error.id = "error-date"
        error.innerHTML = `Les dates ne sont pas valides. La date de départ doit être dans le futur. La date de fin doit être après la date de début et avoir moins de 365 jours d'écart avec celle-ci.`
        $('#div_id_date_debut #id_date_debut', form)?.classList.add('fr-input--error')
        $('#div_id_date_fin #id_date_fin', form)?.classList.add('fr-input--error')
        $('#div_id_date_debut .fr-input-group', form)?.classList.add('fr-input-group--error')
        $('#div_id_date_fin .fr-input-group', form)?.classList.add('fr-input-group--error')
        $('#div_id_date_fin', form)?.after(error)
    } else {
        $('#div_id_date_debut #id_date_debut', form)?.classList.remove('fr-input--error')
        $('#div_id_date_fin #id_date_fin', form)?.classList.remove('fr-input--error')
        $('#div_id_date_debut .fr-input-group', form)?.classList.remove('fr-input-group--error')
        $('#div_id_date_fin .fr-input-group', form)?.classList.remove('fr-input-group--error')
    }
}

function handleDisciplineChanged(event: DOMEvent<HTMLSelectElement>) {
    const circuitInput = $<HTMLInputElement>('#id_circuit')
    if (isVTM(event.target.value)) {
        show(circuitInput?.parentElement)
    } else {
        hide(circuitInput?.parentElement)
        if (circuitInput?.checked) {
            circuitInput!.click()
        }
    }
    if (event.target.value) ajouterLiensPageAide(window.Openscop.url_aide_by_discipline_id, event.target.value, $('#div_id_discipline'), $('#contenu-aide-en-ajax')!)
}

function handleStepChanged(event: Event) {
    const step = (event as StepperChangeEvent).detail.step
    if (step === 5) initSitePratique()
    if (step === 6) {
        searchForm()
    }
}

function initAutocomplete() {
    const inputActivite = $<HTMLInputElement>('#id_extra_activite')
    if (!inputActivite) return
    const autocompleteUrl = inputActivite.dataset.autocomplete
    if (autocompleteUrl) {
        autocomplete<any>({
            input: inputActivite, emptyMsg: 'Aucun résultat', debounceWaitMs: 300, preventSubmit: 1, disableAutoSelect: true, fetch: (text, update) => {
                $get(autocompleteUrl, {term: text}).then((data) => {
                    update(data.body)
                })
            }, onSelect: (item) => {
                $get(window.Openscop.url_discipline_by_activite_name, {name: item.value}).then((data) => {
                    const disiciplineInput = $<HTMLSelectElement>('#id_discipline')?.slim
                    const activiteInput = $<HTMLSelectElement>('#id_activite')?.slim
                    if (disiciplineInput && activiteInput) {
                        disiciplineInput.setSelected(data.body)
                        activiteInput.selectEl.addEventListener('change', () => {
                            $get(window.Openscop.url_activite_by_name, {name: item.value}).then((data) => {
                                requestAnimationFrame(() => {
                                    // @ts-ignore
                                    activiteInput.setSelected(parseInt(data.body))
                                })
                            });
                        }, {once: true})
                    }
                })
            }, render: (item) => {
                const div = document.createElement('div')
                div.innerHTML = item.match
                return div
            }
        })
    }
}

function initSitePratique() {
    const form = $<HTMLFormElement>('#evenement-form');
    const site_options = $("#site_options")
    const options_vtm = $("#site_options_vtm")
    const options_emprise = $("#options_emprise")
    const options_circuit = $("#options_circuit")
    if (form) {
        const formData = new FormData(form)

        const hasClassement = !!formData.get("competition")
        const concentrationVTM = $('#div_id_site_pratique_concentration_vtm')
        if (hasClassement) {
            hide(concentrationVTM)
            resetAllOptionsWithName("site_pratique_concentration_vtm")
        } else {
            show(concentrationVTM)
        }
        const discipline = String(formData.get('discipline'))
        const isVtm = isVTM(discipline)
        if (isVtm) {
            site_options?.classList.add("fr-col-6")
            show(options_vtm)
            if (formData.get('emprise')) {
                show(options_emprise)
                options_circuit?.classList.add("options-circuit")
            } else {
                hide(options_emprise)
                resetAllOptionsWithName("type_circuit");
                options_circuit?.classList.remove("options-circuit")
            }
            if (formData.get('type_circuit')) {
                show(options_circuit)
            } else {
                hide(options_circuit)
                resetAllOptionsWithName("type_circuit");
            }
        } else {
            site_options?.classList.remove("fr-col-6")
            hide(options_vtm)
            hide(options_circuit)
            show(options_emprise)
        }
    }
}

function toggleTypeCircuit(checked: boolean, stepper: Stepper) {
    const options_circuit = $("#options_circuit")
    if (checked) {
        show(options_circuit)
    } else {
        hide(options_circuit)
        resetAllOptionsWithName("type_circuit");
    }
    checkCanGoToNextStep(stepper.currentStep)
}

function toggleSitePratique(stepper: Stepper) {
    const site_pratique_terrain = $<HTMLInputElement>('#id_site_pratique_terrain')
    const site_pratique_parcours = $<HTMLInputElement>('#id_site_pratique_parcours')
    const site_pratique_parcours_liaison = $<HTMLInputElement>('#id_site_pratique_parcours_liaison')
    const site_pratique_zone_evolution = $<HTMLInputElement>('#id_site_pratique_zone_evolution')
    const site_pratique_concentration_vtm = $<HTMLInputElement>('#id_site_pratique_concentration_vtm')
    const options_emprise = $("#options_emprise")
    const options_circuit = $("#options_circuit")

    if (site_pratique_parcours?.checked || site_pratique_parcours_liaison?.checked || site_pratique_terrain?.checked || site_pratique_zone_evolution?.checked || site_pratique_concentration_vtm?.checked) {
        show(options_emprise)
        options_circuit?.classList.add("options-circuit")
    } else {
        hide(options_emprise)
        options_circuit?.classList.remove("options-circuit")
        resetAllOptionsWithName("emprise");
    }
    handleCircuitNonPermanentSelectionner()
    checkCanGoToNextStep(stepper.currentStep)
}

function showNotice(message: string) {
    hide($('#show-non-form'))
    hide($<HTMLElement>('#show-paris'));

    $<HTMLElement>('#info-cerfa-text')!.innerHTML = message;
    show($('#show-form'))
    hide($('#id-submit'))
}

function showCerfa(message: string) {
    hide($('#show-non-form'))
    hide($('#show-paris'));
    $<HTMLElement>('#info-cerfa-text')!.innerHTML = message;
    show($('#show-form'))
    show($('#id-submit'))
}

function showNonForm() {
    hide($('#show-paris'));
    hide($('#show-form'))
    show($('#show-non-form'))
}

function showParis() {
    hide($('#show-form'))
    hide($('#show-non-form'))
    show($<HTMLElement>('#show-paris'));
    $('#paris-non')?.addEventListener('click', () => {
        showNonForm()
    })
}

function searchForm() {
    // Récupérer les données du formulaire
    // show-form => si cerfa
    // show-paris => si non cerfa
    // show-non-form => si non a question paris
    // redirect => si oui a question paris
    const form = $<HTMLFormElement>('#evenement-form');
    if (form) {
        const formData = new FormData(form)
        if (formData.get('discipline') == "" || formData.get('nb_participants') == "" || formData.get('emprise') == window.Openscop.emprise.null || (formData.get('site_pratique_circuit_sport_meca') && formData.get('type_circuit') == window.Openscop.circuit.null)) {
            showNotice("Questionnaire incomplet pour la recherche du formulaire !")
        } else {
            const formulaire = recherche_formulaire(formData);
            if (formulaire !== "") {
                $<HTMLInputElement>('#id_formulaire')!.value = formulaire;
                const get_url = '/aide/CERFA/' + formulaire;
                $get(get_url, {embed: true}).then(function (data) {
                    if (data.body.search('CERFA N°') !== -1) {
                        showCerfa(data.body)
                    } else {
                        showNotice(data.body)
                    }
                });
            } else {
                showParis()
            }
        }
    }
}

function isVTM(discipline: string) {
    const listvtl = Array.isArray(window.Openscop.listevtm) ? window.Openscop.listevtm : [window.Openscop.listevtm]
    for (const vtm of listvtl) {
        if (discipline == vtm) {
            return true;
        }
    }
    return false;
}

function recherche_formulaire(form: FormData) {
    let formulaire = "";
    const discipline = String(form.get('discipline'))
    if (discipline) {
        const disciplineName = String($<HTMLOptionElement>('#id_discipline > option:checked')?.text)
        const isVtm = isVTM(discipline)
        const emprise = String(form.get('emprise'))
        const circuit = Boolean(form.get('site_pratique_circuit_sport_meca'))
        const competition = Boolean(form.get('competition'))
        const nb_participants = Number(form.get('nb_participants'))
        const type_circuit = String(form.get('type_circuit'))
        // DVTM
        if(isVtm) {
            if (isDVTM(isVtm, circuit, emprise, competition, nb_participants)) {
                formulaire = "Dvtm";
            } else if (isDVTMCIR(isVtm, circuit, type_circuit, emprise)) {
                formulaire = "Dvtmcir";
            } else {
                formulaire = "Avtm";
            }
        }
        if (isDNM(isVtm, emprise, competition, disciplineName, nb_participants)) {
            formulaire = "Dnm";
        }
        if (isDNMC(isVtm, emprise, competition, disciplineName, nb_participants)) {
            formulaire = "Dnmc";
        }
        if (isDCNM(isVtm, emprise, competition, disciplineName)) {
            formulaire = "Dcnm";
        }
        if (isDCNMC(isVtm, emprise, competition, disciplineName)) {
            formulaire = "Dcnmc";
        }
    }
    return formulaire;
}

function isDCNMC(isVtm: boolean, emprise: string, competition: boolean, discipline: string) {
    return (!isVtm
        && (
            emprise == window.Openscop.emprise.partiel
            || emprise == window.Openscop.emprise.total
            || emprise == window.Openscop.emprise.temp
        ) && competition
        && cyclisme_disciplines_competitif.includes(discipline))
}

function isDCNM(isVtm: boolean, emprise: string, competition: boolean, discipline: string) {
    return !isVtm
        && (
            emprise == window.Openscop.emprise.partiel
            || emprise == window.Openscop.emprise.total
            || emprise == window.Openscop.emprise.temp
        ) && competition
        && !cyclisme_disciplines_competitif.includes(discipline)
}

function isDNMC(isVtm: boolean, emprise: string, competition: boolean, discipline: string, nb_participants: number) {
    return (!isVtm
        && (
            emprise == window.Openscop.emprise.partiel
            || emprise == window.Openscop.emprise.total
            || emprise == window.Openscop.emprise.temp
        ) && !competition
        && nb_participants >= 100
        && cyclisme_disciplines_all.includes(discipline))
}

function isDNM(isVtm: boolean, emprise: string, competition: boolean, discipline: string, nb_participants: number) {
    return (!isVtm
        && (
            emprise == window.Openscop.emprise.partiel
            || emprise == window.Openscop.emprise.total
            || emprise == window.Openscop.emprise.temp
        ) && !competition
        && nb_participants >= 100
        && !cyclisme_disciplines_all.includes(discipline))
}

function isDVTM(isVtm: boolean, circuit: boolean, emprise: string, competition: boolean, nb_participants: number) {
    return (isVtm
        && !circuit
        && (
            emprise == window.Openscop.emprise.partiel
            || emprise == window.Openscop.emprise.total
        ) && !competition
        && nb_participants >= 50)
}

function isDVTMCIR(isVtm: boolean, circuit: boolean, type_circuit: string, emprise: string) {
    return (isVtm
        && circuit
        && type_circuit == window.Openscop.circuit.permanent_homologue
        && (emprise == "null" || emprise == window.Openscop.emprise.hors))
}

function updateIcones() {
    const diciplineElement = $<HTMLSelectElement>('#id_discipline')!
    const labelDicipline = $<HTMLLabelElement>(`[for="${diciplineElement.id}"]`)
    const nbParticipants = Number($<HTMLInputElement>('#id_nb_participants')?.value) || 0
    const labelNbParticipant = $<HTMLLabelElement>('[for="id_nb_participants"]')
    const selectedDicipline = $<HTMLOptionElement>('option:checked', diciplineElement)

    if (labelNbParticipant && labelDicipline) {
        removeChildElementByClass(labelDicipline, 'recherche-icon')
        removeChildElementByClass(labelNbParticipant, 'recherche-icon')
    }
    if (isVTM(diciplineElement.value)) {
        updateLabelIcon(labelDicipline, ivtm)
        if (nbParticipants > 50) {
            updateLabelIcon(labelNbParticipant, igroup)
        }
    } else {
        if (cyclisme_disciplines_all.includes(selectedDicipline?.innerText ?? "")) {
            updateLabelIcon(labelDicipline, icycl)
        } else {
            updateLabelIcon(labelDicipline, i_vtm)
        }
        if (nbParticipants > 100) {
            updateLabelIcon(labelNbParticipant, igroup)
        }
    }
}

function updateLabelIcon(label: HTMLLabelElement | null, icon: HTMLElement, parentIsFlex: boolean = false) {
    if (label) {
        const original = $<HTMLElement>('.recherche-icon', parentIsFlex ? label.parentElement! : label)
        const iconContainer = createElement('span', ['float-end', 'd-none', 'recherche-icon'])
        iconContainer.appendChild(icon)
        addLabelInformations(label, iconContainer)
        if (original) {
            fadeOutFadeIn(original, iconContainer).then(() => original.remove())
        } else fadeIn(iconContainer)
    }
}

function updateCompetitionIcon(element: HTMLInputElement | null) {
    if (element) {
        const label = $<HTMLLabelElement>(`[for="${element.id}"]`)
        let icon = i_comp
        if (element.checked) {
            icon = icomp
        }
        updateLabelIcon(label, icon, true)
    }
}

function handleCircuitNonPermanentSelectionner() {
    const form = $<HTMLFormElement>('#evenement-form');
    if (form) {
        const formData = new FormData(form)
        const emprise = formData.get("emprise") ?? null
        const circuit = formData.get("type_circuit") ?? null
        if (circuit === "1" && emprise === null) {
            requestAnimationFrame(() => {
                $('#id_site_pratique_terrain')?.click()
                $('#id_id_emprise_1')?.click()
            })
        }
    }
}